import { LocalStorage as _LocalStorage } from '@codeleap/web'
import UAParser from 'ua-parser-js'

export const userAgentParser = new UAParser()

export const LocalStorageKeys = {
  TESTER: '@CodeleapTester',
  LOCALE: '@locale',
  PERSIST_AUTH: '@auth.has_user',
  IN_REAUTHENTICATION: '@auth.in_reauthentication',
  QUESTIONS_LAST_AUTO_OPENENED: '@questions.last_auto_opened',
  ONBOARDING_QUESTIONS: '@onboarding_questions',
  HAS_SKIPPED_EMAIL_VERIFICATION: '@hasSkippedEmailVerification',
  AMPLITUDE_DEVICE_ID: '@amplitude.device_id',
  DEV_MODE: '@devMode',
  ANON_ID: 'requestAnonId',
  FEED_HELP_OVERLAY: '@feed.help_overlay',
  LOGGED_OUT_HURDLE: '@hurdle.logger_out',
  IMPERSONATING: '@impersonating',
  LESSON_STORE: '@lesson.store',
  CONTRIBUTE_ONBOARDING: '@contribute.onboarding',
  HURDLE_FREE_PLAYED: '@hurdle.free',
}

export const LocalStorage = new _LocalStorage(LocalStorageKeys)

export const IS_SSR = typeof window === 'undefined'
